import { Select } from '@automata/ui';
import { logger } from '@automata/utils';
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material/Select';
import { useCallback } from 'react';

import { selectDataExportOutputConnectorsById } from '../../features/workflow/selectors';
import { useAppSelector } from '../../hooks';

interface ConnectorSelectProps {
  label: string;
  value?: string;
  onChange: (value: string | undefined) => void;
}

export const ConnectorSelect = ({
  label,
  value,
  onChange,
}: ConnectorSelectProps) => {
  const connectors = useAppSelector(selectDataExportOutputConnectorsById);

  const handleChange = useCallback(
    (e: SelectChangeEvent<unknown>) => {
      const value = e.target.value;
      if (value === undefined || typeof value === 'string') {
        onChange(value);
      } else {
        logger.error('ContentField: unexpected value type for:', value);
      }
    },
    [onChange]
  );

  return (
    <Select
      label={label}
      placeholder="Select connector"
      disabled={connectors.length === 1}
      value={value}
      onChange={handleChange}
    >
      {connectors.map((item) => (
        <MenuItem key={item.id} value={item.id}>
          {item.name}
        </MenuItem>
      ))}
    </Select>
  );
};
